import { Card, Table, Flex, Typography } from "antd";
import { radius, border, shadow, neutral, spacing, typography } from "../../theme/tokens";

/**
 * Khung bảng CMS chuẩn (band 4 của khung 4 dải):
 * Card bọc [tiêu đề + badge đếm?] + [tabs?] + [toolbar/toolbarRight?] + Table.
 *
 * Chuẩn hóa pagination ([10,20,50] + showTotal) để mọi màn list nhất quán,
 * tránh mỗi màn tự chế filter/phân trang (nguồn gốc bug mất filter khi đổi trang).
 *
 * Mọi prop khác (columns, dataSource, loading, rowKey, scroll, locale...) truyền thẳng cho Table.
 *
 * @param {string} title  Tiêu đề thẻ (tuỳ chọn).
 * @param {number} count  Số bản ghi hiện badge cạnh tiêu đề (bỏ trống là không hiện).
 */
const DEFAULT_PAGINATION = {
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ["10", "20", "50"],
  showTotal: (total, range) => `Hiển thị ${range[0]}–${range[1]} trong tổng ${total} giá trị`,
};

export default function CmsTableCard({
  title,
  count,
  tabs,
  toolbar,
  toolbarRight,
  pagination,
  scroll,
  style,
  ...tableProps
}) {
  const mergedPagination =
    pagination === false ? false : { ...DEFAULT_PAGINATION, ...(pagination || {}) };

  /*
   * Bảng CMS nào cũng nhiều cột, không cuộn ngang được thì nó đẩy vỡ layout ở màn hẹp.
   * Mặc định "max-content" chỉ sinh thanh cuộn khi thật sự thiếu chỗ; trang vẫn override
   * được (truyền scroll khác, hoặc scroll={false} nếu cố ý không cuộn).
   */
  const mergedScroll = scroll === false ? undefined : scroll || { x: "max-content" };

  const header = title ? (
    <Flex align="center" gap={spacing[2]}>
      <Typography.Text
        strong
        style={{ fontSize: typography.size.md, color: neutral[900] }}
      >
        {title}
      </Typography.Text>
      {count > 0 && (
        <span
          style={{
            background: neutral[100],
            color: neutral[600],
            borderRadius: radius.pill,
            padding: "1px 10px",
            fontSize: typography.size.sm,
            fontWeight: typography.weight.semibold,
            lineHeight: "20px",
          }}
        >
          {count}
        </span>
      )}
    </Flex>
  ) : null;

  return (
    <Card
      title={header}
      styles={{ body: { padding: 0 } }}
      style={{
        borderRadius: radius.md,
        border: border.hairline,
        boxShadow: shadow.xs,
        overflow: "hidden",
        ...style,
      }}
    >
      {tabs && (
        <div style={{ borderBottom: border.hairline, padding: "0 16px" }}>{tabs}</div>
      )}

      {(toolbar || toolbarRight) && (
        <Flex
          justify="space-between"
          align="center"
          gap={12}
          wrap="wrap"
          style={{ padding: 12 }}
        >
          <Flex gap={8} wrap="wrap" align="center">
            {toolbar}
          </Flex>
          {toolbarRight && (
            <Flex gap={8} align="center">
              {toolbarRight}
            </Flex>
          )}
        </Flex>
      )}

      <Table size="small" pagination={mergedPagination} scroll={mergedScroll} {...tableProps} />
    </Card>
  );
}
